const STORAGE_KEY = 'redirectAfterLogin'

/**
 * Persist the path the user was trying to reach so we can send them
 * there after a successful login / auth recovery.
 */
export function savePostLoginRedirect(fullPath: string): void {
  localStorage.setItem(STORAGE_KEY, fullPath)
}

/**
 * Read and clear the saved redirect.
 * Falls back to the `redirect` route-query param that the router guard
 * attaches when sending users to the Login page.
 *
 * Returns `null` when there is nowhere specific to redirect.
 */
export function consumePostLoginRedirect(routeQueryRedirect?: string | null): string | null {
  const saved = localStorage.getItem(STORAGE_KEY)
  if (saved) {
    localStorage.removeItem(STORAGE_KEY)
    return saved
  }
  return routeQueryRedirect || null
}
